import html5 from "../images/stacks/html5.png";
import css3 from "../images/stacks/css3.png";
import javascript from "../images/stacks/javascript.png";
import react from "../images/stacks/react.png";
import tailwindcss from "../images/stacks/tailwindcss.png";
import redux from "../images/stacks/redux.png";
import nextjs from "../images/stacks/Next.js.png";
import typescript from "../images/stacks/typescript.png";

export const TECH_STACK_LOGOS = [
  {
    name: "HTML5",
    logo: html5,
  },
  {
    name: "CSS3",
    logo: css3,
  },
  {
    name: "JavaScript",
    logo: javascript,
  },
  {
    name: "TypeScript",
    logo: typescript,
  },
  {
    name: "React",
    logo: react,
  },
  {
    name: "Redux",
    logo: redux,
  },

  {
    name: "NEXT.JS",
    logo: nextjs,
  },

  {
    name: "Tailwind CSS",
    logo: tailwindcss,
  },
];

export const RESUME_LINK =
  "https://drive.google.com/file/d/1-63-WtO9KxYkK8SE3IgSkx2wt4pPMJvw/view";
